/* eslint-disable react-refresh/only-export-components */

import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Button, Col, Form, Row, Space, Spin, Typography } from 'antd';
import { useState } from 'react';
import { queryTaskStatistics } from '../../../features/statistics/api';
import { AccountStatisticsTable } from '../../../features/statistics/components/account-statistics-table';
import { CreditStatisticsTable } from '../../../features/statistics/components/credit-statistics-table';
import { ModelStatisticsTable } from '../../../features/statistics/components/model-statistics-table';
import { TaskStatisticsCharts } from '../../../features/statistics/components/task-statistics-charts';
import { TaskStatisticsSummary } from '../../../features/statistics/components/task-statistics-summary';
import { TimeRangePicker } from '../../../features/statistics/components/time-range-picker';
import { todayRange } from '../../../features/statistics/constants';

export const Route = createFileRoute('/_creator-center/admin/statistics/task')({
  component: Statistics,
});

function Statistics() {
  const [rangeType, setRangeType] = useState(todayRange);
  const [queryRange, setQueryRange] = useState(todayRange);

  const {
    data: task_statistics,
    isFetching: is_task_fetching,
    refetch,
  } = useQuery(queryTaskStatistics(queryRange[0], queryRange[1]));

  const handleQuery = () => {
    if (rangeType[0] === queryRange[0] && rangeType[1] === queryRange[1]) {
      refetch();
      return;
    }
    setQueryRange(rangeType);
  };

  const handleReset = () => {
    const resetRange: [number, number] = [...todayRange];
    setRangeType(resetRange);
    if (resetRange[0] === queryRange[0] && resetRange[1] === queryRange[1]) {
      refetch();
      return;
    }
    setQueryRange(resetRange);
  };

  return (
    <div className="h-full overflow-auto bg-white p-4">
      <div className="mb-4">
        <Typography.Title level={4} style={{ margin: 0 }}>
          任务统计数据
        </Typography.Title>
      </div>
      <Form className="!mb-4" layout="inline" onFinish={handleQuery}>
        <Form.Item label="统计时间">
          <TimeRangePicker value={rangeType} onChange={setRangeType} />
        </Form.Item>
        <Space>
          <Button variant="solid" color="primary" htmlType="submit">
            查询
          </Button>
          <Button variant="outlined" color="default" onClick={handleReset}>
            重置
          </Button>
        </Space>
      </Form>
      <Spin spinning={is_task_fetching}>
        <Space className="w-full" orientation="vertical" size={16}>
          <TaskStatisticsSummary data={task_statistics} />

          <TaskStatisticsCharts
            accountStats={task_statistics?.account_stats ?? []}
            modelStats={task_statistics?.model_stats ?? []}
            departmentStats={task_statistics?.department_stats ?? []}
          />

          <Row gutter={[16, 16]}>
            <Col xs={24} xl={12}>
              <AccountStatisticsTable
                data={task_statistics?.account_stats ?? []}
              />
            </Col>
            <Col xs={24} xl={12}>
              <CreditStatisticsTable
                rangeTime={task_statistics?.range_time}
                loading={is_task_fetching}
                data={task_statistics?.account_stats ?? []}
              />
            </Col>
            <Col xs={24} xl={12}>
              <ModelStatisticsTable data={task_statistics?.model_stats ?? []} />
            </Col>
          </Row>
        </Space>
      </Spin>
    </div>
  );
}
